import {
  Box,
  Card,
  CardContent,
  Stack,
  SvgIcon,
  Typography,
} from '@mui/material';
import { ReactElement } from 'react';
import { AppPrimaryButton } from 'shared/components/AppComponents';

import { ReactComponent as Upload } from 'assets/images/ic_upload.svg';
import { ReactComponent as Document } from 'assets/images/ic_document.svg';

const EmptyDocument = (props: any): ReactElement => {
  const { setShowUpload, title, subTitle, showButton = true } = props;
  return (
    <Box className="feedback-container">
      <Card variant="outlined">
        <CardContent>
          <SvgIcon
            component={Document}
            inheritViewBox
            className="view-icon"
            fontSize="inherit"
          />
          <Stack
            direction="column"
            spacing={4}
            justifyContent="center"
            alignItems="center"
          >
            <Typography variant="h6">{title}</Typography>
            <Typography component="span">{subTitle}</Typography>
            {showButton && (
              <AppPrimaryButton
                title="Upload Your First Document"
                onClick={() => {
                  setShowUpload(true);
                }}
                startIcon={
                  <SvgIcon
                    component={Upload}
                    inheritViewBox
                    className="view-icon"
                    fontSize="small"
                    htmlColor="#ffff"
                  />
                }
                // onClick={() => navigate('/incidents/add')}
              />
            )}
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default EmptyDocument;
